import { AuthUserDto, SessionDto } from '../api/models';

export type IRefresherToken = {
  sub: number;
  iss: string;
  type: 'refresher';
  email: string;
};
export type JwtPayload = {
  sub: number;
  iss: 'AH-APP';
  email: string;
  role: AuthUserDto['role'];
  name: string;
};

export class SessionDtoExtended implements SessionDto {
  accessToken: string;
  accessTokenParsed: JwtPayload;
  refreshToken: string;
  refreshTokenParsed: IRefresherToken;

  constructor(session: SessionDto) {
    this.accessToken = session.accessToken;
    this.refreshToken = session.refreshToken;

    // Fill in the parsed tokens
    this.accessTokenParsed = JSON.parse(atob(this.accessToken.split('.')[1]));
    this.refreshTokenParsed = JSON.parse(atob(this.refreshToken.split('.')[1]));
  }
}
